import {pdfjs} from 'react-pdf';
import pdfWorkerSrc from 'pdfjs-dist/build/pdf.worker.min.mjs?url';

/**
 * Point pdf.js at a worker that exists. Import this module for its side effect; nothing to call.
 *
 * ⚠ THE ASSIGNMENT MUST BE UNCONDITIONAL. react-pdf 10 runs
 * `pdfjs.GlobalWorkerOptions.workerSrc = 'pdf.worker.mjs'` at import time — a bare specifier that
 * resolves to nothing. Under react-pdf 7 the option started empty, so a
 * `if (!pdfjs.GlobalWorkerOptions.workerSrc)` guard read as "nobody set this yet"; against v10 that
 * test is always false and the real URL is silently dropped, which is how the invoice preview broke
 * while the uploader — which assigned unconditionally — kept working (H1MVP-4756).
 *
 * ⚠ `?url` RATHER THAN `new URL('pdfjs-dist/...', import.meta.url)`, because the second form is
 * sensitive to where THIS FILE lives. Vite rewrites it only when it can statically resolve the
 * specifier; when it cannot, it silently emits a path relative to the importing module —
 * `/src/utils/pdfjs-dist/build/pdf.worker.min.mjs` — which 404s. So the broken URL changes if the
 * module moves, and nothing reports a problem. `?url` always yields the package-relative path.
 *
 * Neither form validates that the file is actually there: with the worker deleted, `?url` still
 * emits its URL and serves 200. If PDFs are dead, check that `pdfjs-dist` is installed at the
 * version package.json pins and that `build/pdf.worker.min.mjs` exists — under pdfjs 3 that
 * directory holds `.js` files and no `.mjs` at all, so a tree that skipped an install cannot work.
 */
pdfjs.GlobalWorkerOptions.workerSrc = pdfWorkerSrc;
